<template>
  <div>
    <button class="btn btn--mod btn--stat" :class="getStatStyle()">
      {{ text }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String
    }
  },
  data() {
    return {
      text: ''
    };
  },
  methods: {
    getStatStyle() {
      switch (this.status) {
        case 'Nov':
          this.text = this.status;
          return 'btn--new';
        case 'Aktivno':
          this.text = this.status;
          return 'btn--low';
        case 'Neaktivno':
          this.text = this.status;
          return 'btn--private';
        case 'Otvoren':
          this.text = this.status;
          return 'btn--in-progress';
        case 'U toku':
          this.text = this.status;
          return 'btn--high';
        case 'Zatvoren':
          this.text = this.status;
          return 'btn--opened';
        case '1':
        case 'Nizak':
          this.text = 'Nizak';
          return 'btn--low';
        case '2':
        case 'Srednji':
          this.text = 'Srednji';
          return 'btn--medium';
        case '3':
        case 'Visok':
          this.text = 'Visok';
          return 'btn--high';
        case 'Privatan':
          this.text = this.status;
          return 'btn--private';
        case 'Javan':
          this.text = this.status;
          return 'btn--public';
        case 'Projekat':
          this.text = this.status;
          return 'btn--project';
        default:
          this.text = this.status;
          return 'btn--low';
      }
    }
  }
};
</script>

<style scoped langs="scss">
.btn--stat {
  border-radius: 10px;
  min-width: 6rem;
  height: 2rem;
  text-align: center;
  padding: 0.25rem;
}

.btn:not(:disabled):not(.disabled) {
  cursor: default;
}

.btn--stat:hover {
  cursor: default;
}

.btn--stat:focus {
  box-shadow: 0 0 0 0;
}

.btn--new {
  background-color: #ecb043;
}

.btn--low {
  background-color: var(--primary-color);
  color: white;
}

.btn--in-progress {
  background-color: #375b9d;
  color: white;
}

.btn--high {
  background-color: #f44336;
  color: white;
}

.btn--opened {
  background-color: #f4ef88;
}

.btn--medium {
  background-color: #ffc107;
}

.btn--private {
  background-color: #757575;
  color: white;
}

.btn--public {
  background-color: #d24c77;
  color: white;
}
.btn--project {
  background-color: #c1666b;
  color: white;
}
</style>
